import React from 'react';
import { Breadcrumb, BreadcrumbItem } from 'reactstrap';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { inject } from 'mobx-react';

import BreadcrumbPath from '../../../types/BreadcrumbPath';
import Icon from '../Icon';
import globalTranslations from '../../../i18n/globalTranslations';
import SEOSchema from '../../head/SEOSchema';
import { LocationContextPropType } from '../../../services/LocationContext';
import SchemaType from "../../../types/seo/SchemaType";

const Breadcrumbs = ({
  path,
  locationContext
}) => {
  const getSchemaData = () => {
    const itemListSchema = getItemListSchema();

    return {
      '@context': 'https://schema.org/',
      '@type': SchemaType.BREADCRUMB_LIST,
      itemListElement: itemListSchema,
      numberOfItems: itemListSchema.length,
    };
  };

  const getItemListSchema = () => {
    const baseUrlSchema = `${locationContext.protocol}//${locationContext.host}`;

    return path.map((item, index) => ({
      '@type': SchemaType.LIST_ITEM,
      name: item.text,
      item: `${baseUrlSchema}${item.url ? item.url : item.text}`,
      position: index + 1,
    }));
  };

  const items = path.map((item, index) => {
    const itemTextInner = <span>{item.text}</span>;
    const itemText = item.url ? (
      <Link to={item.url}>{itemTextInner}</Link>
    ) : (
      <span>{itemTextInner}</span>
    );

    return (
      <BreadcrumbItem
        key={`${index}_${item.text}`}
        active={index === path.length - 1}
      >
        {itemText}
      </BreadcrumbItem>
    );
  });

  return (
    <div className="Breadcrumbs">
      <SEOSchema data={getSchemaData()} />
      <Breadcrumb>
        <BreadcrumbItem>
          <Link to="/">
            <Icon name="home" />
            <span className="sr-only">
              <FormattedMessage {...globalTranslations.homeTitle} />
            </span>
          </Link>
        </BreadcrumbItem>
        {items}
      </Breadcrumb>
    </div>
  );
}

Breadcrumbs.propTypes = {
  path: BreadcrumbPath.isRequired,
  locationContext: LocationContextPropType.isRequired,
};

export default inject('locationContext')(Breadcrumbs);
